// ============================================
// LAYOUT - Auth Layout (Login/Register)
// ============================================

import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '@almacenes/core';

export const AuthLayout = () => {
  const checkAuth = useAuthStore((state) => state.checkAuth);
  const isAuthenticated = checkAuth();

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="h-screen overflow-hidden">
      <Outlet />
    </div>
  );
};
